import React from 'react';
import CarrierLucideIcon from 'components/CarrierLucideIcon/CarrierLucideIcon';
import style from './carrierCard.module.scss';
import propTypes from 'prop-types';
import { stringTrimmer } from 'helpers/strings';

function CarrierCard({
  name,
  type,
  carrierIcon,
  carrierIconColor,
  active,
  setActive = () => {}
}) {
  return (
    <div
      className={`${style.carrierCard} ${
        active === name ? style.active : null
      }`}
      onClick={() => setActive({ name, type })}
    >
      <div className={style.carrierName}>
        <CarrierLucideIcon
          name={carrierIcon}
          color={carrierIconColor}
          whiteIcon={active === name}
        />
        <span>{stringTrimmer(name, 17)}</span>
      </div>
    </div>
  );
}

CarrierCard.propTypes = {
  name: propTypes.string,
  carrierIcon: propTypes.string,
  carrierIconColor: propTypes.string,
  active: propTypes.string,
  type: propTypes.string,
  setActive: propTypes.func
};

export default CarrierCard;
